import { render, staticRenderFns } from "./BuildIndividualContactsFromList.vue?vue&type=template&id=3ad36594&scoped=true"
import script from "./BuildIndividualContactsFromList.vue?vue&type=script&lang=js"
export * from "./BuildIndividualContactsFromList.vue?vue&type=script&lang=js"
import style0 from "./BuildIndividualContactsFromList.vue?vue&type=style&index=0&id=3ad36594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad36594",
  null
  
)

export default component.exports